/*
 * @license
 * Copyright Hitec Luxembourg. All Rights Reserved.
 */

import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class ToastService {
  constructor(
    private translateService: TranslateService,
    private snackBar: MatSnackBar
  ) {
  }

  public showToasterSuccess(msg: string): void {
    this.showLiteralToast(msg, 'toast-sucess-css', 3000);
  }

  public showToasterInfo(msg: string): void {
    this.showLiteralToast(msg, 'toast-info-css', 3000);
  }

  public showToasterError(msg: string): void {
    this.showLiteralToast(msg, 'toast-error-css', 61000);
  }

  /********TOAST************************************************************************/

  private showLiteralToast(msg: string, cssClass: string, duration: number = 2000) {
    this.snackBar.open(this.translateService.instant(msg), 'Ok', {
      horizontalPosition: <MatSnackBarHorizontalPosition>'center',
      verticalPosition: <MatSnackBarVerticalPosition>'bottom',
      duration: duration,
      panelClass: [cssClass]
    });
  }

  /********end TOAST************************************************************************/

}
